module.exports = __webpack_public_path__ + "img/APS_title.37938e71.svg";